<template>
  <div class="page">
    <!-- 顶部搜索框 start -->
    <div class="topFocusWap" :style = "{ backgroundImage : 'url(' + clients.logoH5 + ')' }">
      <div class="searchBox">
        <input type="text" class="searchIpt" :placeholder="collectionCountText" @input="inputChane" @keyup.enter="toSearch">
        <div class="btn-search" @click="toSearch" />
      </div>
    </div>
    <!-- 顶部搜索框 end -->
    <!-- 特色专题 start -->
    <div class="specialEnt" style="padding-bottom:10px">
      <h3 class="digTit">{{clients.clinetTitleMain}}</h3>
      <div class="specilList" :class="isMore?'':'top'">
        <div v-for="(item,index) in topics" :key="index" class="link" @click="toSearchTopic(item)">#<em>{{ item.topicName }}</em></div>
      </div>
      <div class="listmore" @click="()=>{isMore=!isMore}">{{ !isMore?"查看全部专题":'收起' }}</div>
    </div>
    <!-- 特色专题 end -->

    <!-- 数字特藏 start -->
    <div class="digColl">
      <h3 class="digTit">{{clients.collectionTheme}}
        <span class="showAll" @click="tosourcelist">全部 ></span>
      </h3>

      <!-- digList start -->
      <div class="digList digList-home">
        <div v-for="(item,index) in colls" :key="index" class="itm" @click="toDetail(item)">
          <div class="itm-top">
            <h4 class="t">{{ item.collectionName }}</h4>
            <p class="desc">{{ item.description }}</p>
            <div class="img" :style="{background:'url(' + item.preview +')','backgroundPosition':'center','backgroundSize':'cover'}" />
          </div>
          <div class="entLabel">
            <span><em v-if="item.pictureNumber>0">{{ item.pictureNumber }}图片</em><em v-if="parseInt(item.videoNumber)>0">&nbsp;&nbsp;{{ item.videoNumber }}视频</em><em v-if="parseInt(item.audioNumber)>0">&nbsp;&nbsp;{{ item.audioNumber }}音频</em></span>
            <span v-for="(cate,index) in item.listCategory" :key="index" class="cateType"><em>{{ cate.cateName || '-' }} </em><em>/</em></span>
          </div>
        </div>
      </div>
    <!-- digList end -->
    </div>
    <!-- 数字特藏 end -->

    <!-- idxBanner start -->
    <div class="idxBanner">
      <div class="img" v-for="(item,index) in banners" :key="index">
        <img :src="item.bannerImg" @click="bannerLink(item)">
      </div>
      <!-- <div class="img">
        <img :src="banner1" @click="torecDetail(10)">
      </div>
      <div class="img">
        <img :src="banner2" @click="torecDetail(7)">
      </div> -->
    </div>
    <!-- idxBanner end -->

    <!-- 导航 start -->
    <div class="naviPosition" />
    <div class="digNavigate">
      <router-link class="navItm active" :to="{ name: 'Waphome' }">
        <img src="../../../images/home.png" class="img-normal">
        <img src="../../../images/home_select.png" class="img-active">
        <label>首页</label>
      </router-link>
      <router-link class="navItm" :to="{ name: 'Waplist' }">
        <img src="../../../images/res.png" class="img-normal">
        <img src="../../../images/res_select.png" class="img-active">
        <label>{{clients.collectionTheme?clients.collectionTheme:'特藏'}}</label>
      </router-link>
      <router-link class="navItm" :to="{ name: 'Wapcertified' }">
        <img src="../../../images/upload.jpg" class="img-normal">
        <img src="../../../images/upload_select.jpg" class="img-active">
        <label>上传</label>
      </router-link>
      <router-link class="navItm" :to="{ name: 'Wapuser' }">
        <img src="../../../images/use.png" class="img-normal">
        <img src="../../../images/use_select.png" class="img-active">
        <label>我的</label>
      </router-link>
    </div>
  <!-- 导航 end -->
  </div>
</template>

<script>
import commonapi from '../../../api/common.js'
import api from '../../../api/home.js'
import searchModel from '../../../models/search.js'
// import user from '../../../models/user.js'
export default {
  name: 'Waphome',
  data() {
    return {
      isMore: false,
      colls: null,
      topics: null,
      collectionCountText: '',
      banner1: 'https://img.libraryplus.bjadks.cn/library/1/20210408144512_9202.jpg',
      banner2: 'https://img.libraryplus.bjadks.cn/library/1/9243055c-5495-4889-8b92-1f6958a6721f.jpg',
      banners:[],
      clients: {}
    }
  },
  created() {
    this.requestbanner()
    this.request();
    this.requestclient();
    
  },
  mounted(){
    let that = this;
     this.$store.dispatch('search/setKeyword', '')
    console.log('that.$store.getters.application ',that.$store.getters.application )
    // setTimeout(() => {
    //   that.clients = that.$store.getters.application  
    // }, 1500);
  },
  methods: {
     bannerLink(v) {
      // const routeData = this.$router.resolve({
      //   name: 'Resource',
      //   query: {
      //     rsId: v,
      //     permission: 1
      //   }
      // })
      // window.open(routeData.href, '_blank')
      window.open(v.bannerLink, '_blank')
    },
      //获取应用信息
    requestclient() {
      const that = this;
      api
        .requestclient({ tenantId: this.$store.getters.tenantId })
        .then(r => {
          that.clients = r.data;
        })
        .catch(err => {
          console.log(err);
        });
    },
    //获取banner
    requestbanner() {
      const that = this 
      api.requestbanner({ tenantId: this.$store.getters.tenantId }).then(r => {
        that.banners = r.data
      }).catch(err => {
        console.log(err)
      })     
    },
    request() {
      const that = this
      api.requestcoll({ tenantId: this.$store.getters.tenantId }).then(r => { // 获取特藏
        that.colls = r.data
        console.log(this.colls)
      }).catch(error => {
        console.error(error)
      })
      api.requesttopic({ tenantId: this.$store.getters.tenantId }).then(r => { // 获取专题d
        this.topics = r.data
        console.log(this.topics)
      }).catch(error => {
        console.error(error)
      })
      commonapi.collectionCount({
        tenantId: this.$store.getters.tenantId
      }).then(r => {
        this.collectionCountText = '在' + r.data + '条'+clients.collectionTheme+'中检索'
      })
    },
    toDetail(v) {
      this.$router.push({
        name: 'Wapdetail',
        query: {
          rsId: v.id,
          permission: v.permissionRange
        }
      })
    },

    torecDetail(v) {
      this.$router.push({
        name: 'Wapdetail',
        query: {
          rsId: v,
          permission: 1
        }
      })
    },

    tosourcelist() {
      this.$router.push({
        name: 'Waplist',
        params: {
          type: 1,
          data: {}
        }
      })
    },
    toSearch() {
      searchModel.viewData = { params:{}, display: null, type: '' }
      this.$router.push({
        name: 'Waplist'
      })
    },
    inputChane(v) {
      console.log('searchModel',searchModel)
        this.$store.dispatch("search/setKeyword", v.target.value);
        this.$store.dispatch('search/setType', v.target.value)
      
    },
    toSearchTopic(v) {
      this.$store.dispatch('search/setKeyword', '')
      searchModel.viewData = { params: { specialSubject: v.id }, display: v.topicName, type: 'specialSubject' }
      this.$router.push({
        name: 'Waplist'
      })
    }
  }
}
</script>

<style src="@/styles/wap.scss" lang="scss" scoped></style>
<style scoped>
  .listmore{

    height: .8rem;
    color: black;
    font-size: .3rem;
    line-height: .8rem;
    text-align: center;
    font-weight: normal;
    color: #004d99;
    margin: 0 .36rem;
     box-sizing: border-box;
    border-radius: .12rem;
    background: #fff;
    box-shadow: 0 0.01rem 0.02rem rgba(0, 0, 0, 0.2);

  }
  .top{
    /* height: 105px; */
    height: 1.80rem;
    padding-bottom: 0.2rem;

  }
</style>
